import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function TenantIndexPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/tenant/dashboard", { replace: true });
  }, [navigate]);
  return null;
}